import About from '../components/About'
import Greeting from '../components/Greeting';
import Projects from './Projects';
import Header from '../components/Header'

export default function Home() {  return (
    <div 
      className='subpixel-antialiased font-sans w-screen scroll-smooth'>
      <div className='fixed object-top pb-16 md:mb-40'>
        <Header />
      </div>
      <Greeting />
      <div className='bg-bgpurple-10/10 h-[1px] max-w-xs sm:max-w-sm md:max-w-7xl m-auto'/>
      <div id="about" >
        <About />
      </div>
      <div className='bg-bgpurple-10/10 h-[1px] max-w-xs sm:max-w-sm md:max-w-7xl m-auto'/>
      <Projects />
    </div>
  )
}
function setData(json: any): any {
  throw new Error('Function not implemented.');
}

